// Authentication utility functions
const TOKEN_KEY = 'auth_token';
const USER_KEY = 'user';
const AGENT_KEY = 'agent';

export const authUtils = {
  // Token management
  setToken: (token) => {
    localStorage.setItem(TOKEN_KEY, token);
  },

  getToken: () => {
    return localStorage.getItem(TOKEN_KEY);
  },

  removeToken: () => {
    localStorage.removeItem(TOKEN_KEY);
  },

  // User management
  setUser: (user) => {
    localStorage.setItem(USER_KEY, JSON.stringify(user));
  },

  getUser: () => {
    const user = localStorage.getItem(USER_KEY);
    return user ? JSON.parse(user) : null;
  },

  removeUser: () => {
    localStorage.removeItem(USER_KEY);
  },

  // Agent management
  setAgent: (agent) => {
    localStorage.setItem(AGENT_KEY, JSON.stringify(agent));
  },

  getAgent: () => {
    const agent = localStorage.getItem(AGENT_KEY);
    return agent ? JSON.parse(agent) : null;
  },

  removeAgent: () => {
    localStorage.removeItem(AGENT_KEY);
  },

  // Complete logout
  logout: () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
    localStorage.removeItem(AGENT_KEY);
  },

  // Check if user is authenticated
  isAuthenticated: () => {
    return !!localStorage.getItem(TOKEN_KEY);
  },

  // Get auth header for API requests
  getAuthHeader: () => {
    const token = localStorage.getItem(TOKEN_KEY);
    return token ? { Authorization: `Bearer ${token}` } : {};
  },

  // Decode JWT token (basic, without verification)
  decodeToken: (token) => {
    try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(atob(base64).split('').map((c) => {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
      return JSON.parse(jsonPayload);
    } catch (error) {
      return null;
    }
  },

  // Check if token is expired
  isTokenExpired: (token) => {
    if (!token) return true;
    const decoded = authUtils.decodeToken(token);
    if (!decoded || !decoded.exp) return true;
    return Date.now() >= decoded.exp * 1000;
  },

  // Validate and refresh token if needed
  validateToken: () => {
    const token = authUtils.getToken();
    if (!token || authUtils.isTokenExpired(token)) {
      authUtils.logout();
      return false;
    }
    return true;
  }
};

export default authUtils;
